import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { useCallback } from 'react';
import { useCheckoutStoreContext } from '../../context';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { ORDER_STATUS } from 'src/constants/order';
import { localeStore } from 'src/mobx/localesStore';
import { leaveWithoutSaving } from 'src/utils/modalConfirmations';
import Icon from 'src/view/components/Controls/Icon/Icon';
import { history } from '~/services/history';
import getOrderViewPath from '~/view/screens/CheckoutScreen/getOrderViewPath';
import getOrdersPath from '~/view/screens/CheckoutScreen/getOrdersPath';

const OrderEditHeader: React.FC = observer((): JSX.Element | null => {
  const { store: checkoutStore } = useCheckoutStoreContext();

  const onIconClick = useCallback(() => {
    leaveWithoutSaving({
      onConfirm: () => {
        if (checkoutStore.dependencies.order?.order_status_code === ORDER_STATUS.DRAFT) {
          checkoutStore.discard();
          return;
        }

        if (checkoutStore.dependencies.order) {
          history.push(getOrderViewPath(checkoutStore.parentStore, checkoutStore.dependencies.order?.id), toJS(checkoutStore.dependencies.order));
        } else {
          history.push(getOrdersPath(checkoutStore.parentStore));
        }
      },
    });
  }, []);

  // if there is no order or this is not an order editing, then we display null
  if (!checkoutStore.dependencies.order || checkoutStore.dependencies.order.order_status_code === ORDER_STATUS.DRAFT) return null;

  return (
    <div className="d-flex align-items-center">
      <Icon name={Icons.IcArrow} onPress={onIconClick} size={24} className="color-mainblue mt-4 mr-4 cursor-pointer" />
      <p className="text-size-26 family-bold mt-4">
        {localeStore.t('Edit Order')} #{checkoutStore.dependencies.order.order_key} —{' '}
        {localeStore.t(`${checkoutStore.dependencies.order.order_status_code}_status`)}
      </p>
    </div>
  );
});

export default OrderEditHeader;
